<template>
  <a-modal
    :title="name"
    :width="1200"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <!--表单-->
      <a-table :columns="columns"
               :data-source="data"
               :pagination="false"
               bordered
      >
        <!--<a slot="name" slot-scope="text">{{ text }}</a>-->
        <template slot="avatar" slot-scope="text, record">
          <img :src="text" alt="" style="width: 50px;height: 50px">
        </template>
      </a-table>
      <div style="margin-top: 20px;margin-bottom: 50px">
        <div style="margin-bottom: 20px">请选择销售人员</div>
        <div class="table-page-search-wrapper" style="margin-bottom: 10px">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="6" :sm="18">
                <a-form-item label="手机号" :labelCol="labelCol"
                             :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入手机号" v-model="queryParam.phone"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="18">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.stafftable.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="Reset()">重置</a-button>
            </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <s-table
          ref="stafftable"
          size="default"
          :rowKey="(record) => record.id"
          :columns="staffColumns"
          :data="loadData"
          showPagination="true"
        >
          <a-radio-group v-model="checkedStaff" @change="onChange" slot="action" slot-scope="text, record, index">
            <a-radio :value="record.staffNo"></a-radio>
          </a-radio-group>
        </s-table>
        <a-col align="center" :md="24" :sm="24">
          <a-button @click="handleSubmit" type="primary">{{bindName}}</a-button>
          <a-button @click="handleCancel" style="margin-left: 10px">取消</a-button>
        </a-col>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import {postAxios, getAxios} from '@/api/request'
  import {STable, Ellipsis} from '@/components'

  const formList = {
    userNo: '',
    avatar: '',
    nickName: '',
    sex: ''
  }
  export default {
    name: 'staffList',
    components: {
      STable,
      Ellipsis
    },
    data() {
      return {
        // 验证组件
        fieldRule,
        queryParam: {
          phone: ''
        },
        name: '',
        mode: '',
        formData: {...formList},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        visible: false,
        confirmLoading: false,
        columns: [
          {
            title: '用户编号',
            dataIndex: 'userNo',
            ellipsis: true
          },
          {
            title: '头像',
            dataIndex: 'avatar',
            ellipsis: true,
            scopedSlots: {customRender: 'avatar'}
          },
          {
            title: '昵称',
            ellipsis: true,
            dataIndex: 'nickName'
          },
          {
            title: '性别',
            ellipsis: true,
            dataIndex: 'sex',
            customRender: (text, row, index) => {
              if (text === 1) {
                return '男'
              } else if (text === 2) {
                return '女'
              } else {
                return '其他'
              }
            }
          },
          {
            title: '销售员编号',
            ellipsis: true,
            dataIndex: 'sellerNo'
          },
          {
            title: '销售员名',
            ellipsis: true,
            dataIndex: 'sellerName'
          },
          {
            title: '关联门店',
            ellipsis: true,
            dataIndex: 'shopName'
          }
        ],
        data: [],
        orderDetail: {
          submitOrderNum: '0',
          orderMoney: '0',
          orderNum: '0',
          carNum: '0'
        },
        userNo: '',
        //    form: this.$form.createForm(this), // 注册后，才能通过表单拉取数据
        // 员工订单表
        checkedStaff: '',
        relationType: '',
        bindName: '绑定',
        staffColumns: [
          {
            title: '',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: {customRender: 'action'}
          },
          {
            title: '员工编号',
            dataIndex: 'staffNo'
          },
          {
            title: '员工姓名',
            dataIndex: 'name'
          },
          {
            title: '手机号',
            dataIndex: 'phone'
          },
          {
            title: '店铺名称',
            dataIndex: 'shopName'
          },
          {
            title: '赠送权限',
            dataIndex: 'authGive',
            customRender: (text, row, index) => {
              if (text) {
                return '是'
              } else {
                return '否'
              }
            }
          },
          {
            title: '后台权限',
            dataIndex: 'authAdmin',
            customRender: (text, row, index) => {
              if (text) {
                return '是'
              } else {
                return '否'
              }
            }
          },
          {
            title: '配置权限',
            dataIndex: 'authSetting',
            customRender: (text, row, index) => {
              if (text) {
                return '是'
              } else {
                return '否'
              }
            }
          },
          {
            title: '查阅报表权限',
            dataIndex: 'authReport',
            customRender: (text, row, index) => {
              if (text) {
                return '是'
              } else {
                return '否'
              }
            }
          }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        loadData: parameter => {
          const parms = {}
          parms.pageNo = parameter.pageNum
          parms.pageSize = parameter.pageSize
          parms.staffNo = this.checkedStaff
          parms.phone = this.queryParam.phone
          return postAxios('staffList', parms)
            .then(res => {
              const data = {}
//              res = res.data
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        },
        selectedRows: []
      }
    },
    methods: {
      edit(record) {
        this.name = '绑定员工'
        this.bindName = '绑定'
        this.visible = true
        this.data = []
        if (record) {
          this.userNo = record.userNo
          this.loadUserDetail(this.userNo)
          // this.data.push(this.formData)
          this.getOrder(record.userNo)
          // this.checkedStaff = record.sellerNo
          setTimeout(() => {
            this.relationType = 'staff'
            this.$refs.stafftable.refresh()
          }, 1)
        }
      },
      unBind(record) {
        this.name = '解除绑定'
        this.bindName = '解绑'
        this.visible = true
        this.data = []
        if (record) {
          this.userNo = record.userNo
          // this.formData = record
          this.data.push(this.formData)
          this.getOrder(record.userNo)
          this.checkedStaff = record.sellerNo
          this.getUserDetail(this.userNo)
          this.relationType = 'user'
          setTimeout(() => {
            this.$refs.stafftable.refresh()
          }, 1)
        }
      },
      onChange(e) {
        console.log('radio checked', e.target.value)
        this.checkedStaff = e.target.value
      },
      // 获取用户订单详情
      getOrder(userNo) {
        const parms = {}
        parms.userNo = userNo
        return postAxios('userOrderCount', parms).then(res => {
          this.orderDetail = res
        })
      },
      loadUserDetail(userNo) {
        const parms = {}
        parms.userNo = userNo
        return postAxios('userDetail', parms).then(res => {
          this.formData = res
          this.data.push(res)
        })
      },
      handleSubmit() {
        if (this.relationType === 'staff') {
          if (this.checkedStaff === '') {
            alert('请选择员工！')
            return false
          }
        } else {
          this.checkedStaff = ''
        }
        const params = {}
        params.userNo = this.userNo
        params.checkedStaff = this.checkedStaff
        params.relationType = this.relationType
        postAxios('userBindStaff', params).then(res => {
          this.confirmLoading = false
          this.handleCancel()
          this.$message.success('新增成功')
          this.$emit('ok', '') // 成功回调
        }).catch(err => {
          console.log(err)
          this.confirmLoading = false
        })
        this.confirmLoading = true
      },
      handleCancel() {
        this.visible = false
        this.confirmLoading = false
        // this.form.resetFields() // 清空表单
        this.formData = {...formList}
      },
      callback(key) {
        console.log(key)
      },
      Reset() {
        this.queryParam.phone = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/userManage/modules/staffList.vue